import React from 'react'
import loadingGif from '../../assets/images/loading.gif'

const LoadingScreen = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
    <img src={loadingGif} alt="Loading..." className="w-32 h-32" />
  </div>
);

export default LoadingScreen